import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { postRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import './InviteColleagues.scss';
var InviteColleagues = /*#__PURE__*/function (_Component) {
  function InviteColleagues(props) {
    var _this;
    _classCallCheck(this, InviteColleagues);
    _this = _callSuper(this, InviteColleagues, [props]);
    _this.state = {
      showModal: false,
      showConfirmationScreen: false,
      errorMessage: null,
      uninvitedColleagues: props.uninvitedColleagues,
      email: '',
      invalidEmail: true,
      invite: [],
      sentInvite: [],
      message: '',
      level: 'invoice_approver'
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleAddEmail = _this.handleAddEmail.bind(_this);
    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.validateEmailUniqueness = _this.validateEmailUniqueness.bind(_this);
    _this.validateEmailDomain = _this.validateEmailDomain.bind(_this);
    _this.toggleInvite = _this.toggleInvite.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.renderSelectColleagues = _this.renderSelectColleagues.bind(_this);
    return _this;
  }
  _inherits(InviteColleagues, _Component);
  return _createClass(InviteColleagues, [{
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        showModal: false,
        showConfirmationScreen: false
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(v) {
      var invalidEmail = this.state.invalidEmail;
      var target = v.target;
      this.setState(_defineProperty({}, target.name, target.value));
      if (target.type === 'email') {
        this.setState({
          invalidEmail: target.value === '' || target.validity.typeMismatch,
          errorMessage: null
        });
      }
      return !invalidEmail;
    }
  }, {
    key: "validateEmailUniqueness",
    value: function validateEmailUniqueness(email) {
      var uninvitedColleagues = this.state.uninvitedColleagues;
      var invitedColleagues = this.props.invitedColleagues;
      return invitedColleagues === null || invitedColleagues.filter(function (f) {
        return f.email === email;
      }).length < 1 && uninvitedColleagues.filter(function (c) {
        return c.email === email && c.invite === true;
      }).length < 1;
    }
  }, {
    key: "validateEmailDomain",
    value: function validateEmailDomain(email, inviterEmailDomain) {
      var limitInvitesWithinCompany = this.props.limitInvitesWithinCompany;
      if (!limitInvitesWithinCompany) {
        return true;
      }
      return email.indexOf("@".concat(inviterEmailDomain), email.length - "@".concat(inviterEmailDomain).length) !== -1;
    }
  }, {
    key: "handleAddEmail",
    value: function handleAddEmail() {
      var _this$props = this.props,
        limitInvitesWithinCompany = _this$props.limitInvitesWithinCompany,
        inviterEmailDomain = _this$props.inviterEmailDomain;
      var _this$state = this.state,
        email = _this$state.email,
        invite = _this$state.invite,
        uninvitedColleagues = _this$state.uninvitedColleagues;
      if (!this.validateEmailUniqueness(email)) {
        this.setState({
          errorMessage: 'This colleague has already been invited.'
        });
      } else if (limitInvitesWithinCompany && !this.validateEmailDomain(email, inviterEmailDomain)) {
        this.setState({
          errorMessage: 'You can only invite colleagues within your company.'
        });
      } else {
        var colleague = uninvitedColleagues.filter(function (c) {
          return c.email === email;
        })[0];
        if (colleague) {
          colleague.invite = true;
        } else {
          var invitee = {
            email: email,
            name: email,
            invite: true
          };
          uninvitedColleagues.unshift(invitee);
        }
        invite.push(email);
        this.setState({
          invite: invite,
          uninvitedColleagues: uninvitedColleagues,
          email: '',
          invalidEmail: true
        });
      }
    }
  }, {
    key: "handleEnter",
    value: function handleEnter(e) {
      var _this$props2 = this.props,
        location = _this$props2.location,
        resourceId = _this$props2.resourceId;
      if (e.key === 'Enter') {
        e.preventDefault();
        if (this.handleInputChange(e)) {
          this.handleAddEmail();
          analyticsTrack('Clicked Add Email', {
            location: "".concat(location, " - Invite Colleague by Email"),
            resource_id: resourceId
          });
        }
      }
    }
  }, {
    key: "toggleInvite",
    value: function toggleInvite(currentInviteStatus, invitee) {
      var _this$state2 = this.state,
        invite = _this$state2.invite,
        uninvitedColleagues = _this$state2.uninvitedColleagues;
      if (currentInviteStatus) {
        /* eslint no-param-reassign: ["error", { "props": false }] */
        invitee.invite = false;
        this.setState({
          uninvitedColleagues: uninvitedColleagues,
          invite: invite.filter(function (i) {
            return i !== invitee.email;
          })
        });
      } else {
        invitee.invite = true;
        invite.push(invitee.email);
        this.setState({
          invite: invite,
          uninvitedColleagues: uninvitedColleagues
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        resource = _this$props3.resource,
        resourceId = _this$props3.resourceId,
        inviteUrl = _this$props3.inviteUrl,
        handleFeedbacks = _this$props3.handleFeedbacks,
        preventCloseModalAfterSubmit = _this$props3.preventCloseModalAfterSubmit,
        location = _this$props3.location,
        confirmationScreenAfterSend = _this$props3.confirmationScreenAfterSend;
      var _this$state3 = this.state,
        invite = _this$state3.invite,
        message = _this$state3.message,
        level = _this$state3.level,
        uninvitedColleagues = _this$state3.uninvitedColleagues;
      postRequest(inviteUrl, {
        emails: invite,
        message: message,
        level: level,
        resource_id: resourceId
      }, csrfToken).then(function (response) {
        _this2.setState({
          uninvitedColleagues: uninvitedColleagues.filter(function (c) {
            return !c.invite;
          }),
          sentInvite: invite,
          // for confirmation screen
          invite: [],
          showConfirmationScreen: confirmationScreenAfterSend,
          message: ''
        });
        if (!preventCloseModalAfterSubmit) {
          _this2.handleCloseModal();
        }
        handleFeedbacks(response.data, uninvitedColleagues.filter(function (c) {
          return !c.invite;
        }));
        analyticsTrack('Invited Colleagues to Provide Feedback', {
          emails: invite,
          location: "".concat(location, " - Submitted Modal Form"),
          resource_id: resourceId,
          resource: resource
        });
      });
    }
  }, {
    key: "renderSelectColleagues",
    value: function renderSelectColleagues() {
      var _this3 = this;
      var uninvitedColleagues = this.state.uninvitedColleagues;
      var resource = this.props.resource;
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-4"
      }, /*#__PURE__*/React.createElement("p", {
        className: " mb-3 "
      }, "Select colleagues"), /*#__PURE__*/React.createElement("div", {
        className: "scroll-colleagues"
      }, uninvitedColleagues.map(function (colleague) {
        return /*#__PURE__*/React.createElement("div", {
          key: colleague.email,
          tabIndex: 0,
          role: "button",
          className: "g-row--always g-flex-align-center select-colleague select-colleague-".concat(resource, " ").concat(colleague.invite ? 'green' : 'grey'),
          onClick: function onClick() {
            return _this3.toggleInvite(colleague.invite, colleague);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "add-colleague me-2"
        }, /*#__PURE__*/React.createElement("i", {
          className: "".concat(colleague.invite ? 'fa fa-check' : 'far fa', "-square")
        })), /*#__PURE__*/React.createElement("div", {
          className: "fs-hide ".concat(colleague.invite ? 'green' : 'grey')
        }, /*#__PURE__*/React.createElement("div", null, colleague.name ? colleague.name : colleague.email), /*#__PURE__*/React.createElement("div", {
          className: "body-text-3"
        }, colleague.name && colleague.email && colleague.email)));
      })));
    }
  }, {
    key: "renderButtonOrLink",
    value: function renderButtonOrLink() {
      var _this$props4 = this.props,
        styleType = _this$props4.styleType,
        styleClass = _this$props4.styleClass,
        cta = _this$props4.cta,
        disabled = _this$props4.disabled,
        resource = _this$props4.resource;
      if (styleType === 'button') {
        return /*#__PURE__*/React.createElement("button", {
          disabled: disabled,
          className: "invite-trigger invite-trigger-".concat(resource, " btn ").concat(styleClass),
          onClick: this.handleShowModal
        }, cta);
      }
      if (styleType === 'icon') {
        return /*#__PURE__*/React.createElement("button", {
          className: "btn btn-secondary-no-border",
          onClick: this.handleShowModal,
          type: "button"
        }, /*#__PURE__*/React.createElement("i", {
          className: "".concat(styleClass)
        }), /*#__PURE__*/React.createElement("span", {
          className: "ps-3"
        }, cta));
      }
      return /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "button",
        className: "invite-trigger invite-trigger-".concat(resource, " ").concat(disabled && 'disabled', " body-text-2"),
        onClick: !disabled && this.handleShowModal
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus"
      }), cta);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props5 = this.props,
        resource = _this$props5.resource,
        header = _this$props5.header,
        subtext = _this$props5.subtext,
        cta = _this$props5.cta,
        submitCta = _this$props5.submitCta,
        messageHeader = _this$props5.messageHeader,
        ownerMessagePlaceholder = _this$props5.ownerMessagePlaceholder,
        modalClassName = _this$props5.modalClassName,
        children = _this$props5.children;
      var _this$state4 = this.state,
        invite = _this$state4.invite,
        sentInvite = _this$state4.sentInvite,
        uninvitedColleagues = _this$state4.uninvitedColleagues,
        showModal = _this$state4.showModal,
        email = _this$state4.email,
        errorMessage = _this$state4.errorMessage,
        message = _this$state4.message,
        showConfirmationScreen = _this$state4.showConfirmationScreen;
      var inviteLength = invite ? invite.length : 0;
      var uninvitedColleaguesLength = uninvitedColleagues ? uninvitedColleagues.length : 0;
      return /*#__PURE__*/React.createElement("div", null, this.renderButtonOrLink(), /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleCloseModal,
        className: modalClassName
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "no-border-bottom"
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "invite-colleagues-modal style-guide"
      }, showConfirmationScreen && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, resource, ' ', "successfully shared with:"), sentInvite.map(function (recipient) {
        return /*#__PURE__*/React.createElement("div", {
          className: "body-text-1"
        }, recipient);
      })), !showConfirmationScreen && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: "mb-8"
      }, header), /*#__PURE__*/React.createElement("p", null, subtext), /*#__PURE__*/React.createElement("div", {
        className: "invite-form"
      }, /*#__PURE__*/React.createElement("form", {
        className: "body-text-2",
        onSubmit: function onSubmit(event) {
          return event.preventDefault();
        }
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "email"
      }, "Email addresses"), /*#__PURE__*/React.createElement("input", {
        name: "email",
        className: "fs-hide email ".concat(errorMessage ? 'error-padding' : ''),
        type: "email",
        placeholder: "Press enter after each email address",
        value: email,
        onKeyPress: function onKeyPress(val) {
          return _this4.handleEnter(val);
        },
        onChange: function onChange(val) {
          return _this4.handleInputChange(val);
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "email-warning body-text-3"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), /*#__PURE__*/React.createElement("span", {
        className: "body-text-3 medium-weight"
      }, "Press Enter"), ' ', "after typing the email address"), errorMessage && /*#__PURE__*/React.createElement("div", {
        className: "body-text-3 email-error"
      }, errorMessage), inviteLength + uninvitedColleaguesLength > 0 && this.renderSelectColleagues(), /*#__PURE__*/React.createElement("div", null, uninvitedColleaguesLength > 0 && /*#__PURE__*/React.createElement("hr", {
        className: "mt-40 mb-4"
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "owner-comment"
      }, messageHeader, ' ', /*#__PURE__*/React.createElement("span", {
        className: "muted-gray-text normal-weight"
      }, "(Optional)")), /*#__PURE__*/React.createElement("textarea", {
        name: "message",
        className: "fs-hide owner-comment",
        placeholder: ownerMessagePlaceholder,
        value: message,
        onChange: function onChange(val) {
          return _this4.handleInputChange(val);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: children ? 'right' : 'center'
      }, /*#__PURE__*/React.createElement("button", {
        id: "send-invite-".concat(resource),
        className: "send-invite btn btn-primary",
        disabled: invite.length < 1,
        onClick: this.handleSubmit
      }, submitCta || cta || 'Send Invite'))))))), children));
    }
  }]);
}(Component);
InviteColleagues.propTypes = {
  disabled: PropTypes.bool,
  resource: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  inviteUrl: PropTypes.string.isRequired,
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  uninvitedColleagues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleFeedbacks: PropTypes.func.isRequired,
  styleType: PropTypes.string,
  styleClass: PropTypes.string,
  cta: PropTypes.string,
  header: PropTypes.string,
  subtext: PropTypes.string,
  messageHeader: PropTypes.string,
  ownerMessagePlaceholder: PropTypes.string,
  children: PropTypes.node,
  modalClassName: PropTypes.string,
  preventCloseModalAfterSubmit: PropTypes.bool,
  submitCta: PropTypes.string,
  limitInvitesWithinCompany: PropTypes.bool,
  inviterEmailDomain: PropTypes.string,
  confirmationScreenAfterSend: PropTypes.bool
};
InviteColleagues.defaultProps = {
  disabled: false,
  styleType: 'link',
  styleClass: '',
  cta: 'Add Colleagues',
  header: 'Share with colleagues',
  subtext: 'Colleagues will be able to review and leave comments on the project until Clora starts vetting consultants.',
  messageHeader: 'Add a message for your colleague:',
  ownerMessagePlaceholder: 'Type your message here, what should your colleagues review?',
  children: null,
  modalClassName: '',
  preventCloseModalAfterSubmit: false,
  submitCta: null,
  limitInvitesWithinCompany: false,
  inviterEmailDomain: '',
  confirmationScreenAfterSend: false
};
export default InviteColleagues;